import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { FiAlertCircle } from 'react-icons/fi';
import { Box, Typography, Grid, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import AvailableDateCard from '../../components/AvailableDateCard';

import AvailableDatesStore from '../../stores/AvailableDatesStore';

const availableDatesListStyles = ({ breakpoints }) => ({
  boxErrorMessage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px 8px',
    width: '100%',
    margin: '16px 0px',
    background: '#fdecea',
    '& svg': {
      marginRight: '16px',
    },
    '& p': {
      fontSize: '16px',
    },
    [breakpoints.down('xs')]: {
      '& p': {
        fontSize: '12px',
      },
      '& svg': {
        marginRight: '8px',
      },
    },
  },
  boxAlertMessage: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '16px',
    background: '#e8f4fd',
    borderRadius: '4px',
    marginTop: '16px',

    '& .boxIcon': {
      display: 'flex',
      fontSize: '22px',
      marginRight: '12px',
    },

    '& div p': {
      marginTop: '8px',
      fontSize: '16px',
    },
  },
});

class AvailableDatesList extends Component {
  handleAvailableDateCardClick = date => {
    const { availableDatesStore } = this.props;
    const { setSelectedDate } = availableDatesStore;

    setSelectedDate(date);
  };

  render() {
    const { classes, availableDatesStore } = this.props;
    const {
      isLoading,
      isFailure,
      hasFormError,
      hasUnavailableTechniciansError,
      dates,
    } = availableDatesStore;

    return (
      <>
        {hasFormError && (
          <Typography component="div">
            <Box mt={2} mb={1} fontSize={21} fontWeight="bold" color="#D12E2E">
              Por favor, escolha uma data.
            </Box>
          </Typography>
        )}
        {isLoading ? (
          <Box
            mt={2}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
          >
            <Typography component="div">
              <Box mt={2} mb={1} fontSize={16}>
                Aguarde um instante que estamos buscando as melhores datas para
                você...
              </Box>
            </Typography>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {isFailure && (
              <>
                <Box className={classes.boxErrorMessage}>
                  <FiAlertCircle size={25} color="#611a15" />
                  <Typography>
                    No momento não foi possível carregar as datas disponíveis
                  </Typography>
                </Box>
              </>
            )}
            {hasUnavailableTechniciansError && (
              <>
                <Box className={classes.boxAlertMessage}>
                  <Box className="boxIcon">
                    <FiAlertCircle size={25} color="#2196f3" />
                  </Box>
                  <Box fontSize={16}>
                    <strong>
                      Não encontramos datas disponíveis no momento.
                    </strong>
                    <Typography>
                      Por favor, entre em contato no{' '}
                      <strong>
                        {process.env.REACT_APP_CENTRAL_PHONE_NUMBER}
                      </strong>
                      .
                    </Typography>
                  </Box>
                </Box>
              </>
            )}
            <Box mt={2}>
              <Grid container>
                {dates.map(({ date, selected }) => (
                  <Grid key={date} item xs={6} sm={3} md={3} lg={2} xl={2}>
                    <AvailableDateCard
                      date={date}
                      selected={selected}
                      onClick={() => this.handleAvailableDateCardClick(date)}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </>
        )}
      </>
    );
  }
}

AvailableDatesList.propTypes = {
  classes: PropTypes.object.isRequired,
  availableDatesStore: PropTypes.instanceOf(AvailableDatesStore).isRequired,
};

export default withStyles(availableDatesListStyles)(
  inject('availableDatesStore')(observer(AvailableDatesList))
);
